import React from 'react';
import { Helmet } from 'react-helmet';

const Confidentialite = () => {
  return (
    <div className="bg-[#0B0B0F] min-h-screen text-white">
      <Helmet>
        <title>Politique de confidentialité | YohanVision</title>
        <meta name="description" content="Politique de confidentialité de YohanVision" />
      </Helmet>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-white mb-8 text-center">Politique de Confidentialité</h1>
        
        <div className="bg-gray-900 shadow-md rounded-lg p-6 mb-8 border border-gray-800">
          <h2 className="text-2xl font-semibold text-white mb-4">1. Collecte limitée d'informations</h2>
          <p className="text-gray-300 mb-4">
            Le site YohanVision collecte un minimum de données personnelles lors de votre visite. Nous ne recueillons pas d'informations 
            de navigation ni d'adresses IP à des fins de suivi.
          </p>
          
          <h2 className="text-2xl font-semibold text-white mb-4 mt-8">2. Formulaire de contact</h2>
          <p className="text-gray-300 mb-4">
            Notre site utilise EmailJS pour le traitement des formulaires de contact. Lorsque vous utilisez notre formulaire de contact, 
            les informations que vous fournissez (nom, adresse e-mail, sujet et message) sont transmises via EmailJS pour nous permettre 
            de vous répondre. Ces données ne sont utilisées que pour répondre à votre demande et ne sont pas conservées au-delà du temps nécessaire.
          </p>
          <p className="text-gray-300 mb-4">
            EmailJS peut collecter certaines métadonnées techniques lors de l'envoi de votre message. Pour plus d'informations sur leurs 
            pratiques de confidentialité, veuillez consulter la <a href="https://www.emailjs.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">politique de confidentialité d'EmailJS</a>.
          </p>
          
          <h2 className="text-2xl font-semibold text-white mb-4 mt-8">3. Liens vers les réseaux sociaux</h2>
          <p className="text-gray-300 mb-4">
            Notre site propose des liens vers des moyens de contact (Instagram, Facebook, YouTube) qui vous permettent 
            de communiquer directement avec nous. Ces liens sont fournis uniquement pour faciliter la prise de contact.
          </p>
          <p className="text-gray-300 mb-4">
            Si vous choisissez de nous contacter via ces moyens, les informations que vous nous transmettez volontairement 
            seront utilisées uniquement pour répondre à votre demande et ne seront pas partagées avec des tiers.
          </p>
          
          <h2 className="text-2xl font-semibold text-white mb-4 mt-8">4. Hébergement et sécurité</h2>
          <p className="text-gray-300 mb-4">
            Notre site est hébergé sur Firebase Hosting, un service de Google Cloud Platform. Firebase peut collecter certaines 
            données techniques pour assurer le bon fonctionnement du service, comme les journaux d'accès au serveur. Pour plus 
            d'informations sur leurs pratiques de confidentialité, veuillez consulter la <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">politique de confidentialité de Firebase</a>.
          </p>
          <p className="text-gray-300 mb-4">
            Nous nous engageons à maintenir la sécurité générale du site et à protéger les informations limitées que nous recevons.
          </p>
        </div>
        
        <div className="bg-gray-900 shadow-md rounded-lg p-6 border border-gray-800" id="cookies">
          <h1 className="text-2xl font-bold text-white mb-4">Politique des Cookies</h1>
          
          <h2 className="text-xl font-semibold text-white mb-4">Utilisation limitée de cookies</h2>
          <p className="text-gray-300 mb-4">
            Le site YohanVision utilise un minimum de cookies nécessaires au fonctionnement du site. Firebase Hosting peut utiliser 
            des cookies techniques pour assurer la sécurité et les performances du site.
          </p>
          
          <h2 className="text-xl font-semibold text-white mb-4 mt-6">Outils d'analyse</h2>
          <p className="text-gray-300 mb-4">
            Firebase peut collecter des données d'utilisation anonymes pour améliorer les performances du site. 
            Ces données sont agrégées et ne permettent pas d'identifier personnellement les utilisateurs.
          </p>
          
          <h2 className="text-xl font-semibold text-white mb-4 mt-6">Sites tiers</h2>
          <p className="text-gray-300 mb-4">
            Notre site contient des liens vers des plateformes externes comme Instagram, Facebook et YouTube. 
            Veuillez noter que ces sites tiers peuvent utiliser leurs propres cookies et méthodes de collecte de données 
            selon leurs propres politiques de confidentialité, sur lesquelles nous n'avons aucun contrôle.
          </p>
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-gray-400 text-sm">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Confidentialite;
